"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN = void 0;
var CHAIN_1 = require("./CHAIN");
Object.defineProperty(exports, "CHAIN", { enumerable: true, get: function () { return CHAIN_1.CHAIN; } });
